import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EInvoiceComputingService {
  toTtc(value: number | null, tvaPercent: number | null) {
    if (value) return value * (tvaPercent ? 1 + tvaPercent / 100 : 1);
    return 0;
  }

  computeTva(valueHt: number | null, tvaPercent: number | null) {
    if (valueHt) return valueHt * (tvaPercent ? tvaPercent / 100 : 0);
    return 0;
  }
}
